import { render, staticRenderFns } from "./courseMsg.vue?vue&type=template&id=cc225f4c&"
import script from "./courseMsg.vue?vue&type=script&lang=js&"
export * from "./courseMsg.vue?vue&type=script&lang=js&"
import style0 from "./courseMsg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports